var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 600,
    viewBox: "0 0 1440 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1203.5,
    cy: 107.5,
    r: 12.5,
    fill: "#43B97F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.5,
    cy: 516.5,
    r: 10.5,
    fill: "#43B97F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 484.5,
    r: 10.5,
    fill: "#FF6650"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1351.5,
    cy: 494.5,
    r: 10.5,
    fill: "#FFB951"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.5,
    cy: 93.5,
    r: 17.5,
    fill: "#C280D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.63bde57361d8406e4c4b179370e7a690.svg";
export { ForwardRef as ReactComponent };